<template>
    <w-dialog
        :model-value="show"
        :fullscreen="dialog.fullscreen"
        :width="dialog.width"
        :persistent="dialog.persistent"
        :persistent-no-animation="dialog.persistentNoAnimation"
        title-class="primary-light1--bg white"
        class="max-dialog-height"
    >
        <w-form>
            <w-card class="mb3">
                <w-flex wrap>
                    <w-input
                        v-model="form.nama"
                        :model-value="form.nama"
                        label="Nama"
                        class="xs12 pa3"
                    >
                    </w-input>

                    <w-input
                        v-model="form.no_kp"
                        :model-value="form.no_kp"
                        label="No. Kad Pengenalan"
                        class="xs6 pa3"
                    >
                    </w-input>
                    <w-input
                        v-model="form.no_tel"
                        :model-value="form.no_tel"
                        label="No. Telefon"
                        class="xs6 pa3"
                    >
                    </w-input>
                </w-flex>
            </w-card>
            <w-card>
                <div class="title4">Alamat Di iHasil</div>
                <w-flex wrap>
                    <div class="xs6">
                        <w-flex wrap>
                            <w-input
                                v-model="form.alamat_1"
                                :model-value="form.alamat_1"
                                label="Alamat 1"
                                class="xs12 pa3"
                            >
                            </w-input>
                            <w-input
                                v-model="form.alamat_2"
                                :model-value="form.alamat_2"
                                label="Alamat 2"
                                class="xs12 pa3"
                            >
                            </w-input>
                            <w-input
                                v-model="form.alamat_3"
                                :model-value="form.alamat_3"
                                label="Alamat 3"
                                class="xs12 pa3"
                            >
                            </w-input>
                        </w-flex>
                    </div>
                    <div class="xs6">
                        <div class="xs12 pa3">
                            <z-lookup
                                v-if="render"
                                :label="'Poskod - Bandar'"
                                :url="apiBaseUrl + '/poskod'"
                                :sort="false"
                                :cache="false"
                                v-model="form.lkp_poskod_id"
                            />
                        </div>
                        <div class="xs12 pa3">
                            <z-lookup
                                v-if="render"
                                :label="'Negeri'"
                                :url="apiBaseUrl + '/negeri'"
                                :sort="false"
                                :cache="false"
                                v-model="form.lkp_negeri_id"
                            />
                        </div>
                        <div class="xs12 pa3">
                            <w-button @click="resetAlamat()">
                                Reset alamat
                            </w-button>
                        </div>
                    </div>

                    <w-card class="mt3 xs12" title="Alamat Di SPTB">
                        <span>Klik <b>'Import'</b> untuk mengantikan butiran alamat diatas dengan butiran alamat dari SPTB.</span>
                        <Table
                            :headers="headers"
                            :items="alamats ?? []"
                            :loading="loading"
                        >
                            <template
                                #item-cell.select="{
                                    item,
                                    label,
                                    header,
                                    index,
                                }"
                            >
                                <w-button @click="replaceAlamat(item)">
                                    Import
                                </w-button>
                            </template>
                            <template #no-data>Integration error</template>
                        </Table>
                    </w-card>
                </w-flex>
            </w-card>
        </w-form>
        <template #actions>
            <div class="spacer" />
            <w-button :loading="updating" @click="$emit('close')" class="ml3" text>Tutup</w-button>
            <w-button :loading="updating" @click="update" class="ml3" v-if="$zutil.can('Kemaskini Hakmilik')">Simpan</w-button>
        </template>
    </w-dialog>
</template>

<script setup>
import { ref, watch } from "vue";
import WaveUI from "wave-ui";
import Table from "../../Component/Table";
import { usePage } from '@inertiajs/inertia-vue3';
import axios from "axios";
import { nextTick } from "process";

const props = defineProps({
    auth: [Array, Object],
    show: {
        type: Boolean,
        default: false,
    },
    no_hm: {
        type: String,
        default: false,
    },
    pemilik: {
        type: Object,
    },
});

const emit = defineEmits(["close", "onSuccess"]);
const dialog = ref({
    fullscreen: false,
    persistent: true,
    persistentNoAnimation: false,
    width: "90%",
});
const waveui = new WaveUI();
const apiBaseUrl = process.env.MIX_API_BASE_URL;
const headers = [
    { label: "Tindakan", key: "select" },
    { label: "Nama", key: "nama" },
    { label: "No ID", key: "no_kp" },
    { label: "Alamat 1", key: "alamat_1" },
    { label: "Alamat 2", key: "alamat_2" },
    { label: "Alamat 3", key: "alamat_3" },
    { label: "Poskod", key: "poskod" },
    { label: "Bandar", key: "bandar" },
    { label: "Negeri", key: "negeri" },
];

const alamats = ref([]);

const loading = ref(false);
const render = ref(true);
const updating = ref(false);
const form =   ref({...props.pemilik, sumber:'ihasil'});
watch(
    () => props.show,
    (nv, ov) => {
        getAlamats()
    }
);
const user_id = usePage().props.value.auth.user.id;

async function getAlamats() {
    form.value = {...props.pemilik, sumber:'ihasil'}
    loading.value = true;
    await axios({
        method: "get",
        url: `${apiBaseUrl}/cukai/kemaskini/senarai-alamat`,
        responseType: "json",
        params: {
            no_kp: props.pemilik.no_kp,
            no_hm: props.no_hm,
        },
    })
        .then((e) => {
            alamats.value = e.data.data.sptb;
        })
        .catch(() => {
        })
        .finally((e) => {
            loading.value = false;
        });
}

async function update(){
    updating.value = true
    const l={
        no_hm:props.no_hm,
        pemiliks:form.value,
        user_id:user_id,
    }
    await axios({
        method: "post",
        url: `${apiBaseUrl}/cukai/kemaskini/tukar-alamat`,
        responseType: "json",
        // data: cukai.value,
        data: l
    })
        .then((e) => {
            emit('onSuccess',e.data)
            waveui.notify({
                success: true,
                message: "Berjaya! Maklumat pemilik telah dikemaskini.",
                timeout: 3000,
            });
        })
        .catch((e) => {
            console.error(e)
        })
        .finally((e) => {
            updating.value = false;
        });
}
function replaceAlamat(item){
    Object.keys(item).map(key => {
        form.value[key] = item[key];
    });
    forceRerender()
}

async function forceRerender(){
    render.value = false;
    nextTick(() => {
        render.value = true;
    });
}

function resetAlamat(){
    form.value = {...props.pemilik, sumber:'ihasil'}
    forceRerender()
}
</script>
<style>
.max-dialog-height > div {
    max-height: 95%;
}
</style>
